import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { AddIngredeintItemModel } from 'src/app/pos-panel/models/menu-items/add-ingredient-item.model';
import { InventoryService } from 'src/app/pos-panel/services/inventory/inventory.service';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-add-ingredient-item',
  templateUrl: './add-ingredient-item.component.html',
  styleUrls: ['./add-ingredient-item.component.scss']
})
export class AddIngredientItemComponent implements OnInit {
  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public addIngredientItemModel: AddIngredeintItemModel = new AddIngredeintItemModel();
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public enableEdit: boolean = false;
  public companyId: string;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  public UnitsOfMeasurments: Array<any>;

  //#endregion
  constructor(
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private inventoryService: InventoryService,
    private translate: TranslateService
  ) {
    if (this.config.data != undefined && this.config.data.companyId) {
      this.companyId = this.config.data.companyId;
    }
    if (this.config.data != undefined && this.config.data.companyId && this.config.data.supplyName) {
      this.addIngredientItemModel.name = this.config.data.supplyName;
    }
   }

  ngOnInit(): void {
    this.listUnitsOfMeasurments();
  }
  //#region Public Methods
  listUnitsOfMeasurments(){
    this.inventoryService.listUnitOfMeasurements().subscribe((response)=>{
      this.UnitsOfMeasurments = response;
    });
  }

  addIngredientItem(model: AddIngredeintItemModel){
    this.errorModel = {};
    model.companyId = this.companyId;

    if (model && (!model.name || model.name == "")){
      this.errorModel['Name'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.unitOfMeasurementId || model.unitOfMeasurementId == "")){
      this.errorModel['UnitOfMeasurementId'] = this.requiredFieldErrorMessage;
    }

    if(Object.keys(this.errorModel).length === 0){
      this.spinner = true;
      this.inventoryService.addSupply(model)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            response.unitOfMeasurementShortName = this.UnitsOfMeasurments.find(x => x.id === model.unitOfMeasurementId).shortName;
            this.ref.close(response);
          },
          error: errorResponse => {
            this.spinner = false;
            if (errorResponse.error.StatusCode === -310) {
              const message = errorResponse.error.Message.includes("code") ?
                this.translate.instant('INGREDIENT_ITEM.EXISTING_CODE') :
                this.translate.instant('INGREDIENT_ITEM.EXISTING_NAME');
              this.messageService.add({severity: 'error', summary: message, life: 2000});
            } else {
              this.messageService.add({severity: 'error', summary: "System error", life: 2000});
            }
          }
        })
    }
  }

  editIngredientItem(model: AddIngredeintItemModel){}
  //#endregion
}
